import { Link } from 'react-router-dom';

function Footer() {
  return (
    <>
      {/* FOOTER START */}
      <div className="footer">
        <div className="container">
          <div className="row footer-container">

            {/* About Us Section */}
            <div className="col-sm-12 col-lg-4 f-sec1 text-center text-lg-left">
              <Link to="/about"><h4 className="high-lighted-heading">About Us</h4></Link>
              <h4>Social Network</h4>
              <div className="s-icons">
                <ul className="social-icons-simple">
                  <li>
                    <a href="/" onClick={(e) => e.preventDefault()} className="facebook-bg-hvr">
                      <i className="fab fa-facebook-f" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/touchlinememory" target="_blank" rel="noreferrer" className="twitter-bg-hvr">
                      <i className="fab fa-twitter" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/touchlinememories/" target="_blank" rel="noreferrer" className="instagram-bg-hvr">
                      <i className="fab fa-instagram" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Categories and Tournaments Section */}
            <div className="col-sm-12 col-lg-5 f-sec2">
              <div className="row">
                <div className="col-12 col-md-6">
                  <h4 className="text-center text-md-left">Categories</h4>
                  <ul className="text-center text-md-left">
                    <li><a href="/">Home</a></li>
                    <li><a href="/product-listing">Football</a></li>
                    <li><a href="/product-listing">Basketball</a></li>
                    <li><a href="/product-listing">Tennis</a></li>
                    <li><a href="/product-listing">Ping-pong</a></li>
                    <li><a href="/product-listing">Tournaments</a></li>
                    <li><a href="/product-listing">Hall of Fame</a></li>
                  </ul>
                </div>
                <div className="col-12 col-md-6">
                  <h4 className="text-center text-md-left">Tournaments</h4>
                  <ul className="text-center text-md-left">
                    <li><a href="/product-listing">Best of Europe</a></li>
                    <li><a href="/product-listing">Made in England</a></li>
                    <li><a href="/product-listing">The Big Cup</a></li>
                    <li><a href="/product-listing">Best of the World</a></li>
                    <li><a href="/product-listing">Best of Africa</a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Subscribe Section */}
            <div className="col-sm-12 col-lg-3 f-sec3 text-center text-lg-left">
              <h4>Subscribe</h4>
              <br /><br />
              <form action="">
                <input type="text" placeholder="enter your email" />
                <button type="button" className="btn white-trans-btn-with-white-border">
                  SIGN UP
                </button>
              </form>
            </div>

          </div>

          <div className="row">
            <div className="col-12 footer_notes">
              <p className="whitecolor text-center w-100 wow fadeInDown">
                &copy; 2025 Touchline Memories | <a className="web-link" href="/faq">FAQ</a> | <a className="web-link" href="/privacy-policy">Privacy Policy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* FOOTER END */}
    </>
  );
}

export default Footer;
